module.exports = __webpack_public_path__ + "static/assets/ab844ae9647bd855ed2f15b22c6b9337.svg";